import { render, staticRenderFns } from "./Delinquent.vue?vue&type=template&id=14cc2921"
import script from "./Delinquent.vue?vue&type=script&lang=js"
export * from "./Delinquent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports